import { Stack, useMantineTheme } from '@mantine/core';
import type { JSX } from 'react';
import React from 'react';

import { Flaggable } from '@feathr/extender/components';

import CRMConnectCard from './CRMConnectCard';
import EmbedScriptCard from './EmbedScriptCard';
import StripeConnectCard from './StripeConnectCard';

function FundraisingSettings(): JSX.Element {
  const theme = useMantineTheme();

  return (
    <Stack gap={theme.spacing['4']}>
      <StripeConnectCard />
      <EmbedScriptCard />
      <Flaggable featureName={'showFundraiseCRM'}>
        <CRMConnectCard />
      </Flaggable>
    </Stack>
  );
}

export default FundraisingSettings;
